import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-professional-bodies-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-professional-bodies-ec.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { BuildingPlansService } from "../../../../../shared/services/modules/building-plans.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { ViewApplicationProfessionalBodiesEcConstants } from "./view-application-professional-bodies-ec.constants";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationProfessionalBodiesEcComponent = class ViewApplicationProfessionalBodiesEcComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    viewApplicationService;
    appController;
    recipientSelectService;
    buildingPlansService;
    changeDetectorRefs;
    professionalBodiesForm;
    saveBtnPlaceholder = ViewApplicationProfessionalBodiesEcConstants.SAVE_BUTTON_PLACEHOLDER;
    markEngineerAsNotApplicableLabel = ViewApplicationProfessionalBodiesEcConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL;
    markEngineerAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesEcConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerFormControlName = ViewApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerLabel = ViewApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL;
    markElectricalContractorAsNotApplicableLabel = ViewApplicationProfessionalBodiesEcConstants.MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_LABEL;
    markElectricalContractorAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesEcConstants.MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorFormControlName = ViewApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorLabel = ViewApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL;
    engineerFormControlName = ViewApplicationProfessionalBodiesEcConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = ViewApplicationProfessionalBodiesEcConstants.ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    showEngineer = true;
    showElectricalContractor = true;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = false;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = ViewApplicationProfessionalBodiesEcConstants.ENGINEER_LABEL;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = false;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = ViewApplicationProfessionalBodiesEcConstants.ELECTRICAL_CONTRACTOR_LABEL;
    application;
    getSetProfessionalBodiesObservableSubscription;
    getStepMetaObservableSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, viewApplicationService, appController, recipientSelectService, buildingPlansService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.viewApplicationService = viewApplicationService;
        this.appController = appController;
        this.recipientSelectService = recipientSelectService;
        this.buildingPlansService = buildingPlansService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
    }
    getApplication() {
        const params = {
            $expand: `engineer($expand=groups),electricalContractor($expand=groups),applicant($expand=groups)`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response), error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesEcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onCopyApplicantDetailsToEngineerChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("engineerRecipients").disable();
        }
        else {
            this.professionalBodiesForm.get("engineerRecipients").enable();
        }
    }
    onCopyApplicantDetailsToElectricalContractorChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("electricalContractorRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("electricalContractorRecipient").enable();
        }
    }
    // onMarkEngineerAsNotApplicableChecked(event: any) {
    //   this.showEngineer = event.currentTarget.checked;
    //   if (this.showEngineer === false) {
    //     this.professionalBodiesForm.get("engineerRecipients").disable();
    //     this.professionalBodiesForm.get("engineerRecipients").reset();
    //     const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
    //     copyControl.setValue(false);
    //     copyControl.disable();
    //   } else {
    //     this.professionalBodiesForm.get("engineerRecipients").enable();
    //     const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
    //     copyControl.enable();
    //   }
    // }
    //
    // onMarkElectricalContractorAsNotApplicableChecked(event: any) {
    //   this.showElectricalContractor = event.currentTarget.checked;
    //   if (this.showElectricalContractor === false) {
    //     this.professionalBodiesForm.get("electricalContractorRecipient").disable();
    //     this.professionalBodiesForm.get("electricalContractorRecipient").reset();
    //     const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
    //     copyControl.setValue(false);
    //     copyControl.disable();
    //   } else {
    //     this.professionalBodiesForm.get("electricalContractorRecipient").enable();
    //     const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
    //     copyControl.enable();
    //   }
    // }
    onBtnSaveClicked($event) {
        if (this.professionalBodiesForm.valid) {
            const applicantFormValue = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
            let engineerRecipient = null;
            const engineerRecipientFormControl = this.professionalBodiesForm.get("engineerRecipients");
            const copyApplicantDetailsToEngineer = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer").value;
            const markEngineerAsNotApplicable = this.professionalBodiesForm.get("markEngineerAsNotApplicable").value;
            if (copyApplicantDetailsToEngineer || markEngineerAsNotApplicable) {
                if (copyApplicantDetailsToEngineer) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, engineerRecipientFormControl, true);
                }
                const engineerRecipientFormValue = this.professionalBodiesForm.get("engineerRecipients").value;
                engineerRecipient = RecipientUtils.removeRecipientProperties(engineerRecipientFormValue);
            }
            let electricalContractorRecipient = null;
            const electricalContractorRecipientFormControl = this.professionalBodiesForm.get("electricalContractorRecipient");
            const copyApplicantDetailsToContractor = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor").value;
            const markContractorAsNotApplicable = this.professionalBodiesForm.get("markElectricalContractorAsNotApplicable").value;
            if (markContractorAsNotApplicable || copyApplicantDetailsToContractor) {
                if (copyApplicantDetailsToContractor) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, electricalContractorRecipientFormControl, true);
                }
                const electricalContractorRecipientFormValue = this.professionalBodiesForm.get("electricalContractorRecipient").value;
                electricalContractorRecipient = RecipientUtils.removeRecipientProperties(electricalContractorRecipientFormValue);
            }
            const request = {
                engineer: engineerRecipient, electricalContractor: electricalContractorRecipient
            };
            this.getSetProfessionalBodiesObservableSubscription = this.buildingPlansService.getSetProfessionalBodiesObservable(this.application.id, request)
                .subscribe({
                next: response => {
                    this.getApplication();
                }, error: error => {
                    this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesEcConstants.STEP_TITLE, error, CRUDOperation.Update);
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("professionalBodiesForm");
        this.professionalBodiesForm = form;
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.engineerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.engineerGroup);
            this.contractorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.electricalContractorGroup);
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
        this.getApplication();
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.professionalBodiesForm.reset();
            const application = response.value[0];
            this.application = application;
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(this.application.applicant[0]);
            if (this.application.engineer.length > 0) {
                this.showEngineer = true;
                const recipientControl = this.professionalBodiesForm.get("engineerRecipients");
                recipientControl.enable();
                recipientControl.setValue(this.application.engineer[0]);
                this.professionalBodiesForm.get("markEngineerAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showEngineer = false;
                this.professionalBodiesForm.get("markEngineerAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("engineerRecipients");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
                copyControl.setValue(false);
                copyControl.disable();
            }
            if (this.application.electricalContractor.length > 0) {
                this.showElectricalContractor = true;
                const recipientControl = this.professionalBodiesForm.get("electricalContractorRecipient");
                recipientControl.enable();
                recipientControl.setValue(this.application.electricalContractor[0]);
                this.professionalBodiesForm.get("markElectricalContractorAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showElectricalContractor = false;
                this.professionalBodiesForm.get("markElectricalContractorAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("electricalContractorRecipient");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
                copyControl.setValue(false);
                copyControl.disable();
            }
        }
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: RecipientSelectService },
        { type: BuildingPlansService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationProfessionalBodiesEcComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-professional-bodies-ec",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationProfessionalBodiesEcComponent);
export { ViewApplicationProfessionalBodiesEcComponent };
